import { extensions } from '../../extensions/Extensions';
import { ColorBlend } from './ColorBlend';
import { ColorBurnBlend } from './ColorBurnBlend';
import { ColorDodgeBlend } from './ColorDodgeBlend';
import { DarkenBlend } from './DarkenBlend';
import { DifferenceBlend } from './DifferenceBlend';
import { DivideBlend } from './DivideBlend';
import { ExclusionBlend } from './ExclusionBlend';
import { HardLightBlend } from './HardLightBlend';
import { HardMixBlend } from './HardMixBlend';
import { LightenBlend } from './LightenBlend';
import { LinearBurnBlend } from './LinearBurnBlend';
import { LinearDodgeBlend } from './LinearDodgeBlend';
import { LinearLightBlend } from './LinearLightBlend';
import { LuminosityBlend } from './LuminosityBlend';
import { NegationBlend } from './NegationBlend';
import { OverlayBlend } from './OverlayBlend';
import { PinLightBlend } from './PinLightBlend';
import { SaturationBlend } from './SaturationBlend';
import { SoftLightBlend } from './SoftLightBlend';
import { SubtractBlend } from './SubtractBlend';
import { VividLightBlend } from './VividLightBlend';

extensions.add(
    ColorBlend,
    ColorBurnBlend,
    ColorDodgeBlend,
    DarkenBlend,
    DifferenceBlend,
    DivideBlend,
    ExclusionBlend,
    HardLightBlend,
    HardMixBlend,
    LightenBlend,
    LinearBurnBlend,
    LinearLightBlend,
    LinearDodgeBlend,
    LuminosityBlend,
    NegationBlend,
    OverlayBlend,
    PinLightBlend,
    SaturationBlend,
    SoftLightBlend,
    SubtractBlend,
    VividLightBlend,
);
